/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./tapcoinIndexNew.vue?vue&type=template&id=5c5bbc14&scoped=true"
import script from "./tapcoinIndexNew.vue?vue&type=script&lang=js"
export * from "./tapcoinIndexNew.vue?vue&type=script&lang=js"
import style0 from "./tapcoinIndexNew.vue?vue&type=style&index=0&id=5c5bbc14&prod&lang=scss"
import style1 from "./tapcoinIndexNew.vue?vue&type=style&index=1&id=5c5bbc14&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5bbc14",
  null
  
)

export default component.exports